<template>
  <div class="min-h-screen bg-gray-50">
    <div class="bg-white shadow-sm border-b border-gray-200">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div class="flex items-center justify-between">
          <div>
            <h1 class="text-3xl font-bold text-gray-900">Платежные аккаунты</h1>
            <p class="mt-1 text-sm text-gray-500">
              Управление платежными аккаунтами
            </p>
          </div>
          <button
            @click="openCreateModal"
            class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
          >
            <i class="pi pi-plus mr-2"></i>
            Добавить аккаунт
          </button>
        </div>
      </div>
    </div>

    <div class="container mx-auto px-4 py-8">
      <div class="bg-white shadow-md rounded-lg overflow-hidden">
        <div class="px-6 py-4 border-b border-gray-200 bg-gray-50">
          <div class="flex items-center justify-between">
            <div class="flex items-center space-x-4">
              <button
                @click="showFilters = !showFilters"
                class="flex items-center space-x-2 px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 hover:border-gray-400 transition-colors duration-150"
              >
                <i
                  class="pi transition-transform duration-200"
                  :class="showFilters ? 'pi-chevron-up' : 'pi-chevron-down'"
                ></i>
                <span>Фильтры</span>
                <span
                  v-if="activeFiltersCount > 0"
                  class="inline-flex items-center justify-center w-5 h-5 text-xs font-medium text-white bg-blue-600 rounded-full"
                >
                  {{ activeFiltersCount }}
                </span>
              </button>
              <div class="flex items-center space-x-2">
                <label class="text-sm font-medium text-gray-700"
                  >Сортировка:</label
                >
                <select
                  v-model="filters.sort"
                  @change="loadAccounts"
                  class="px-3 py-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="name">По названию</option>
                  <option value="id">По ID</option>
                  <option value="class_of_service">
                    По классу обслуживания
                  </option>
                  <option value="bio_of_dm">По ФИО ЛПР</option>
                  <option value="site">По сайту</option>
                  <option value="agency_name">По агентству</option>
                </select>
                <button
                  @click="toggleOrder"
                  class="p-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-md transition-colors duration-150"
                  :title="
                    filters.order === 'asc' ? 'По возрастанию' : 'По убыванию'
                  "
                >
                  <i
                    class="pi text-lg transition-all duration-200"
                    :class="
                      filters.order === 'asc' ? 'pi-arrow-up' : 'pi-arrow-down'
                    "
                  ></i>
                </button>
              </div>
            </div>
            <button
              @click="resetFilters"
              class="px-3 py-2 text-sm text-gray-600 bg-white border border-gray-300 rounded-md hover:bg-gray-50 hover:border-gray-400 transition-colors duration-150"
            >
              <i class="pi pi-refresh mr-2"></i>
              Сбросить
            </button>
          </div>
          <div
            v-show="showFilters"
            class="px-6 py-4 border-b border-gray-200 bg-white"
          >
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1"
                  >ID</label
                >
                <input
                  v-model="filters.id"
                  @input="debouncedLoadAccounts"
                  type="number"
                  placeholder="Введите ID..."
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1"
                  >Название</label
                >
                <input
                  v-model="filters.name"
                  @input="debouncedLoadAccounts"
                  type="text"
                  placeholder="Введите название..."
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1"
                  >Сайт</label
                >
                <input
                  v-model="filters.site"
                  @input="debouncedLoadAccounts"
                  type="text"
                  placeholder="Введите сайт..."
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1"
                  >Агентство</label
                >
                <input
                  v-model="filters.agency_name"
                  @input="debouncedLoadAccounts"
                  type="text"
                  placeholder="Введите агентство..."
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1"
                  >Класс обслуживания</label
                >
                <select
                  v-model="filters.class_of_service"
                  @change="loadAccounts"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="">Все классы</option>
                  <option value="base">Base</option>
                  <option value="pro">Pro</option>
                  <option value="premium">Premium</option>
                </select>
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1"
                  >ФИО ЛПР</label
                >
                <input
                  v-model="filters.bio_of_dm"
                  @input="debouncedLoadAccounts"
                  type="text"
                  placeholder="Введите ФИО ЛПР..."
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1"
                  >Телефон ЛПР</label
                >
                <input
                  v-model="filters.tel_of_dm"
                  @input="debouncedLoadAccounts"
                  type="text"
                  placeholder="Введите телефон..."
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700 mb-1"
                  >Telegram ЛПР</label
                >
                <input
                  v-model="filters.telegram_of_dm"
                  @input="debouncedLoadAccounts"
                  type="text"
                  placeholder="Введите telegram..."
                  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
            </div>
          </div>
        </div>

        <div v-if="loading" class="flex justify-center items-center py-12">
          <div
            class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"
          ></div>
        </div>
        <div
          v-else-if="error"
          class="bg-white rounded-lg shadow-sm border border-red-200 p-6"
        >
          <div class="flex items-center">
            <div class="flex-shrink-0">
              <i class="pi pi-exclamation-triangle text-red-400 text-xl"></i>
            </div>
            <div class="ml-3">
              <h3 class="text-sm font-medium text-red-800">Ошибка загрузки</h3>
              <div class="mt-2 text-sm text-red-700">{{ error }}</div>
            </div>
          </div>
        </div>
        <div v-else-if="accounts.length === 0" class="text-center py-12">
          <div
            class="mx-auto h-24 w-24 flex items-center justify-center rounded-full bg-gray-100"
          >
            <i class="pi pi-users text-gray-400 text-3xl"></i>
          </div>
          <h3 class="mt-4 text-lg font-medium text-gray-900">Список пуст</h3>
          <p class="mt-2 text-sm text-gray-500">
            Нажмите "Добавить аккаунт", чтобы создать первый аккаунт
          </p>
        </div>
        <div v-else class="bg-white shadow-sm rounded-lg overflow-hidden">
          <div class="overflow-x-auto">
            <table
              class="min-w-full divide-y divide-gray-200"
              style="min-width: 1400px"
            >
              <thead class="bg-gray-50">
                <tr>
                  <th
                    class="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Просмотр
                  </th>
                  <th
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    ID
                  </th>
                  <th
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Название
                  </th>
                  <th
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Сайт
                  </th>
                  <th
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Агентство
                  </th>
                  <th
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Класс обслуживания
                  </th>
                  <th
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    ФИО ЛПР
                  </th>
                  <th
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Телефон ЛПР
                  </th>
                  <th
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Лимиты клиента по тарифу
                  </th>
                  <th
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Периодичность сбора
                  </th>
                  <th
                    class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider sticky right-0 bg-gray-50 z-10"
                  >
                    Действия
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr
                  v-for="account in accounts"
                  :key="account.id"
                  class="hover:bg-blue-50 hover:shadow-sm transition-all duration-150 cursor-pointer group"
                  @click="viewAccount(account)"
                >
                  <td class="px-6 py-4 whitespace-nowrap text-center">
                    <button
                      @click="viewAccount(account)"
                      class="text-gray-600 hover:text-blue-600 group-hover:text-blue-600 transition-colors duration-150"
                      title="Просмотр"
                    >
                      <i class="pi pi-eye"></i>
                    </button>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    {{ account.id }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    {{ account.name }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <a
                      v-if="account.site"
                      :href="`http://${account.site}`"
                      target="_blank"
                      class="text-blue-600 hover:text-blue-800 hover:underline"
                      @click.stop
                    >
                      {{ account.site }}
                    </a>
                    <span v-else class="text-gray-400">Не указано</span>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    {{ account.agency_name || 'Не указано' }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <span
                      v-if="account.class_of_service"
                      :class="{
                        'px-2 py-1 text-xs font-medium rounded-full': true,
                        'bg-gray-100 text-gray-800':
                          account.class_of_service === 'base',
                        'bg-blue-100 text-blue-800':
                          account.class_of_service === 'pro',
                        'bg-purple-100 text-purple-800':
                          account.class_of_service === 'premium'
                      }"
                    >
                      {{
                        account.class_of_service.charAt(0).toUpperCase() +
                        account.class_of_service.slice(1)
                      }}
                    </span>
                    <span v-else class="text-gray-400">Не указано</span>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    {{ account.bio_of_dm || 'Не указано' }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    {{ account.tel_of_dm || 'Не указано' }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    <div
                      v-if="
                        account.application_limits &&
                        account.application_limits.length
                      "
                      class="text-sm text-gray-900"
                    >
                      <div
                        v-for="limit in account.application_limits"
                        :key="limit.id"
                        class="py-1"
                      >
                        <span class="font-medium">{{
                          limit.application_name
                        }}</span>
                        <span class="text-gray-600">
                          - {{ limit.application_limit.toLocaleString() }}
                        </span>
                      </div>
                    </div>
                    <span v-else class="text-gray-400">Не указано</span>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap">
                    {{ account.frequency_collection || 'Не указано' }}
                  </td>
                  <td
                    class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium sticky right-0 bg-white z-10"
                  >
                    <div
                      class="flex items-center justify-end space-x-2"
                      @click.stop
                    >
                      <button
                        @click="openEditModal(account)"
                        class="text-blue-600 hover:text-blue-900 transition-colors duration-150"
                        title="Редактировать"
                      >
                        <i class="pi pi-pencil"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="bg-gray-50 px-6 py-3 border-t border-gray-200">
            <div class="flex items-center justify-between">
              <div class="flex items-center space-x-4">
                <span class="text-sm text-gray-500">
                  Всего записей: {{ totalCount }}
                </span>
                <div class="flex items-center space-x-2">
                  <span class="text-sm text-gray-500">Показать:</span>
                  <select
                    v-model="filters.limit"
                    class="px-2 py-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    @change="handleLimitChange"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                  </select>
                  <span class="text-sm text-gray-500">записей</span>
                </div>
              </div>
              <div class="flex items-center space-x-2">
                <button
                  @click="exportToCSV"
                  :disabled="exportLoading"
                  class="px-4 py-2 text-sm font-medium text-white bg-green-600 border border-green-600 rounded-md hover:bg-green-700 hover:border-green-700 transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <i v-if="!exportLoading" class="pi pi-download mr-2"></i>
                  <i v-else class="pi pi-spin pi-spinner mr-2"></i>
                  {{ exportLoading ? 'Выгрузка...' : 'Выгрузить в CSV' }}
                </button>
                <button
                  @click="prevPage"
                  :disabled="filters.page <= 1"
                  class="px-3 py-1 text-sm border border-gray-300 rounded-md disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
                >
                  Назад
                </button>
                <span class="text-sm text-gray-500">
                  Страница {{ filters.page }} из
                  {{ Math.ceil(totalCount / filters.limit) }}
                </span>
                <button
                  @click="nextPage"
                  :disabled="
                    filters.page >= Math.ceil(totalCount / filters.limit)
                  "
                  class="px-3 py-1 text-sm border border-gray-300 rounded-md disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
                >
                  Вперед
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <PaymentAccountForm
      :visible="showModal"
      :mode="modalMode"
      :account="editingAccount"
      :agencies="agencies"
      :positions="positions"
      :reasonsOfLeaving="reasonsOfLeaving"
      :userStore="userStore"
      :accountManagerUsers="accountManagerUsers"
      :onClose="closeModal"
      :onSaved="handleFormSaved"
    />
  </div>
</template>

<script setup>
  import { ref, onMounted, computed } from 'vue'
  import { useRouter } from 'vue-router'
  import { useToast } from 'primevue/usetoast'
  import {
    paymentAccountApi,
    agencyApi,
    positionDecisionMakerApi,
    reasonOfLeavingApi,
    userApi
  } from '../services/api'
  import { useUserStore } from '../stores/user'
  import PaymentAccountForm from '../components/PaymentAccountForm.vue'

  const userStore = useUserStore()
  const router = useRouter()
  const toast = useToast()

  const accounts = ref([])
  const agencies = ref([])
  const positions = ref([])
  const reasonsOfLeaving = ref([])
  const accountManagerUsers = ref([])
  const loading = ref(false)
  const exportLoading = ref(false)
  const error = ref('')
  const showModal = ref(false)
  const modalMode = ref('create')
  const editingAccount = ref(null)
  const totalCount = ref(0)

  const showFilters = ref(false)
  const filters = ref({
    id: '',
    name: '',
    site: '',
    agency_name: '',
    class_of_service: '',
    bio_of_dm: '',
    tel_of_dm: '',
    telegram_of_dm: '',
    frequency_collection: '',
    sort: 'name',
    order: 'asc',
    page: 1,
    limit: 100
  })

  const filterFields = [
    'id',
    'name',
    'site',
    'agency_name',
    'class_of_service',
    'bio_of_dm',
    'tel_of_dm',
    'telegram_of_dm',
    'frequency_collection'
  ]

  const activeFiltersCount = computed(() => {
    let count = 0
    filterFields.forEach(field => {
      const value = filters.value[field]
      if (value !== '' && value !== null && value !== undefined) {
        count++
      }
    })
    return count
  })

  const loadAccounts = async (showLoading = true) => {
    if (showLoading) {
      loading.value = true
    }
    error.value = ''
    try {
      const params = {
        limit: filters.value.limit,
        page: filters.value.page,
        sort: filters.value.sort,
        order: filters.value.order
      }

      const filtersObj = {}
      Object.entries(filters.value).forEach(([key, value]) => {
        if (
          value !== '' &&
          value !== null &&
          value !== undefined &&
          !['sort', 'order', 'page', 'limit'].includes(key)
        ) {
          filtersObj[key] = value
        }
      })

      if (Object.keys(filtersObj).length) {
        params.filters = filtersObj
      }

      const response = await paymentAccountApi.getList(params)
      accounts.value = response.payment_accounts || response || []
      totalCount.value = response.total_count || accounts.value.length
    } catch (err) {
      error.value = err.message
      console.error('Error loading accounts:', err)
      toast.add({
        severity: 'error',
        summary: 'Ошибка',
        detail: err.message,
        life: 3000
      })
    } finally {
      if (showLoading) {
        loading.value = false
      }
    }
  }

  const loadAgencies = async () => {
    try {
      const response = await agencyApi.getList({ is_deleted: 0 })
      agencies.value = response?.agencies || response || []
    } catch (err) {
      agencies.value = []
    }
  }

  const loadPositions = async () => {
    try {
      const data = await positionDecisionMakerApi.getList({ is_deleted: 0 })
      positions.value = data.position_decision_makers || data || []
    } catch (err) {
      positions.value = []
    }
  }

  const loadReasons = async () => {
    try {
      const data = await reasonOfLeavingApi.getList({ is_deleted: 0 })
      reasonsOfLeaving.value = data.reasons_of_leaving || data || []
    } catch (err) {
      reasonsOfLeaving.value = []
    }
  }

  const loadAccountManagerUsers = async () => {
    try {
      const response = await userApi.getUsersByRole('ROLE_USER', {
        limit: 9999,
        page: 1
      })
      accountManagerUsers.value = response.users || response || []
    } catch (err) {
      console.error('Error loading users:', err)
      accountManagerUsers.value = []
    }
  }

  const openCreateModal = () => {
    modalMode.value = 'create'
    editingAccount.value = null
    showModal.value = true
  }

  const openEditModal = account => {
    modalMode.value = 'edit'
    editingAccount.value = account
    showModal.value = true
  }

  const closeModal = () => {
    showModal.value = false
    editingAccount.value = null
  }

  const handleFormSaved = () => {
    loadAccounts()
  }

  const viewAccount = account => {
    if (!account || !account.id) {
      return
    }

    try {
      router.push(`/payment-accounts/${account.id}`)
    } catch (error) {
      window.location.href = `/payment-accounts/${account.id}`
    }
  }

  let searchTimeout
  const debouncedLoadAccounts = () => {
    clearTimeout(searchTimeout)
    searchTimeout = setTimeout(() => {
      filters.value.page = 1
      loadAccounts()
    }, 400)
  }

  const prevPage = () => {
    if (filters.value.page > 1) {
      filters.value.page--
      loadAccounts()
    }
  }

  const nextPage = () => {
    const totalPages = Math.ceil(totalCount.value / filters.value.limit)
    if (filters.value.page < totalPages) {
      filters.value.page++
      loadAccounts()
    }
  }

  const handleLimitChange = () => {
    filters.value.page = 1
    loadAccounts()
  }

  const resetFilters = () => {
    filters.value = {
      id: '',
      name: '',
      site: '',
      agency_name: '',
      class_of_service: '',
      bio_of_dm: '',
      tel_of_dm: '',
      telegram_of_dm: '',
      frequency_collection: '',
      sort: 'name',
      order: 'asc',
      page: 1,
      limit: 100
    }
    loadAccounts()
  }

  const toggleOrder = () => {
    filters.value.order = filters.value.order === 'asc' ? 'desc' : 'asc'
    loadAccounts()
  }

  const exportToCSV = async () => {
    exportLoading.value = true

    try {
      const params = {
        page: 1,
        limit: 10000,
        sort: filters.value.sort,
        order: filters.value.order
      }

      const filtersObj = {}
      filterFields.forEach(field => {
        const value = filters.value[field]
        if (value !== '' && value !== null && value !== undefined) {
          filtersObj[field] = value
        }
      })

      if (Object.keys(filtersObj).length > 0) {
        params.filters = filtersObj
      }

      const response = await paymentAccountApi.download(params)

      if (response) {
        const blob = response

        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = `payment_accounts_${new Date().toISOString().split('T')[0]}.csv`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

        URL.revokeObjectURL(link.href)
      }

      toast.add({
        severity: 'success',
        summary: 'Успешно',
        detail: 'Файл CSV успешно выгружен',
        life: 3000
      })
    } catch (error) {
      console.error('Ошибка при экспорте CSV:', error)
      toast.add({
        severity: 'error',
        summary: 'Ошибка',
        detail: 'Не удалось выгрузить файл CSV',
        life: 3000
      })
    } finally {
      exportLoading.value = false
    }
  }

  onMounted(async () => {
    loading.value = true
    try {
      await userStore.fetchAccountManagers()
      await userStore.fetchSaleManagers()
      await userStore.fetchAnalyticLeads()
      await userStore.fetchAllUsers()
      await loadAgencies()
      await loadPositions()
      await loadReasons()
      await loadAccountManagerUsers()
      await loadAccounts(false)
    } finally {
      loading.value = false
    }
  })
</script>
